const updates = [
  { date: '07-31', title: '《星际迷航：新纪元》BD高清版正式上线', tag: '新片上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-30', title: '7月热门电影排行榜TOP50榜单刷新发布', tag: '榜单更新', tagColor: 'bg-accent-100 text-accent-800' },
  { date: '07-29', title: '国产悬疑片《迷雾追踪》豆瓣开分8.7引热议', tag: '热片追踪', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '本站片库总量正式突破50,000部里程碑', tag: '平台动态', tagColor: 'bg-secondary-100 text-secondary-800' },
  { date: '07-27', title: '《速度与激情12》首支预告片全网首发上线', tag: '独家预告', tagColor: 'bg-accent-100 text-accent-800' },
  { date: '07-26', title: '暑期档观影指南：7月必看十大佳片推荐', tag: '编辑推荐', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-25', title: '4K画质专区新增200+经典修复影片入库', tag: '片库扩充', tagColor: 'bg-secondary-100 text-secondary-800' },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            实时追踪电影世界每一刻精彩，不错过任何上新与热点
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 py-4 border-b border-background-200/60 last:border-b-0 group cursor-pointer hover:bg-background-50/50 px-3 -mx-3 rounded-lg transition-colors"
            >
              <span className="text-xs text-foreground-400 font-mono whitespace-nowrap pt-0.5 min-w-[44px]">
                {item.date}
              </span>
              <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${item.tagColor} mt-0.5`}>
                {item.tag}
              </span>
              <p className="text-sm md:text-base text-foreground-800 leading-relaxed group-hover:text-primary-500 transition-colors flex-1">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}